import z from "zod";
import { KnownContentfulEnvironment } from "../types";
import { LocaleSchema } from "../locale";
import { RoleProps } from "contentful-management";

export const LocaleRoleSchema = z.custom<`LocaleSpecificEditor-${string}`>(
  (data) => {
    const asString = z.string().parse(data);

    const [prefix, ...rest] = asString.split("-");
    const localeSuffix = LocaleSchema.parse(rest.join("-"));

    return prefix === "LocaleSpecificEditor" && localeSuffix;
  },
);

export const EsportLocaleRoleSchema =
  z.custom<`LocaleSpecificEsportEditor-${string}`>((data) => {
    const asString = z.string().parse(data);

    const [prefix, ...rest] = asString.split("-");
    const localeSuffix = LocaleSchema.parse(rest.join("-"));

    return prefix === "LocaleSpecificEsportEditor" && localeSuffix;
  });

export const RoleTypeSchema = z
  .enum([
    "CommunityManager",
    "StagingAccess",
    "EsportsManager",
    "CommunityTabAdmin",
    "TagEditor",

    // These two are deprecated, but we need to keep them around to keep the compiler happy...
    "CommunityManagerWithPublish",
    "CommunityManagerWithoutPublish",
  ])
  .or(LocaleRoleSchema)
  .or(EsportLocaleRoleSchema);

export const RoleType = RoleTypeSchema;
export type RoleType = z.infer<typeof RoleTypeSchema>;

export type Role = {
  type: RoleType;
  name: string;
  description: string;
  policies: RoleProps["policies"];
  permissions: RoleProps["permissions"];
};

export const STAGING: KnownContentfulEnvironment = "staging";
export const MASTER: KnownContentfulEnvironment = "master";
